module.exports = __webpack_public_path__ + "static/media/Week 3 Thursday.b90f26de.png";